/**
 * We'll load Vue, jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
import Vue from 'vue';
window.Vue = Vue;
window.$ = window.jQuery = require("jquery");
require("bootstrap");
require("./plugins/base");
require("./plugins/i18n");
require("./plugins/axios");
require("./plugins/alerts");
require("./plugins/ui-blocker");
require("./plugins/typeahead");
require("./plugins/thumbnail");
require("./components/registration");
